import React, { useState } from "react";

import { Button } from "primereact/button";

type CollapsibleTextProps = {
  text: string;
  maxChars?: number;
};

const CollapsibleText: React.FC<CollapsibleTextProps> = ({ text, maxChars = 10 }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const isTruncated = text?.length > maxChars;

  return (
    <>
      {isCollapsed && (
        <span
          onClick={() => isTruncated && setIsCollapsed(false)}
          className={`${isTruncated ? "cursor-pointer " : ""}truncate inline-block vertical-align-middle`}
          style={{ width: `${maxChars}ch` }}
        >
          {text}
        </span>
      )}
      {!isCollapsed && (
        <div className="flex nowrap align-items-center">
          <span>{text}</span>
          <Button
            icon="pi pi-times"
            iconPos="bottom"
            onClick={() => setIsCollapsed(true)}
            className="ml-2 p-button-sm p-button-text p-1"
            style={{ width: "1.3rem" }}
          />
        </div>
      )}
    </>
  );
};

export default CollapsibleText;
